<div class="modal1Main defaultPop">
  <div class="modalHeader">
      <span class="title">
        <i class="fas fa-check"></i>&nbsp;Successfully registered!
      </span>
      <button class="closepop float-right" mat-dialog-close><i class="zmdi zmdi-close"></i></button>
  </div>
  
  <div class="defaultPopCont">
    <p>{{parameters.body}}</p>
    <ng-container *ngIf="isMobile">
      <br><br>
      <p>To get a notification when your draft is starting, please dwonload our mobile app!</p>
    </ng-container>
  </div>
  
  <div class="text-center defaultPopfoot">
    <button mat-raised-button color="primary" class="joinDraftBtn popupBtn" (click)="openAppPopup()">Download App</button>
    <button mat-raised-button color="primary" class="joinDraftBtn popupBtn" (click)="redirectUrl(parameters.invite_url)">Invite Friends</button>
    <!--button mat-raised-button color="primary" class="joinDraftBtn" (click)="redirectUrl(parameters.invite_url)">Set Rankings</button--> 
</div> 
</div>
<ng-template #mobileApp>
  <div class="mobileApp">
    <div class="smart-body">
      <h2>It's Easier With The App!</h2>
      <div class="smart-cardContainer">
        <a href="http://apps.apple.com/us/app/drafters-fantasy-sports/id1273975920/" target="_blank" class="smartbanner-icon">
          <img src="{{assetURL}}/assets/default/new/images/appstore_2.png" alt="">
        </a>
        <a href="https://app2.drafters.info/uC18" target="_blank" class="smartbanner-icon">
            <img src="{{assetURL}}/assets/default/new/images/googlestore_2.png" alt="">
        </a>
      </div>
    </div>
  </div>
  </ng-template>